var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaintBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8337 15.3333C25.8337 15.3333 23.1671 18.2267 23.1671 20C23.1671 20.7072 23.448 21.3855 23.9481 21.8856C24.4482 22.3857 25.1265 22.6667 25.8337 22.6667C26.541 22.6667 27.2193 22.3857 27.7194 21.8856C28.2195 21.3855 28.5004 20.7072 28.5004 20C28.5004 18.2267 25.8337 15.3333 25.8337 15.3333ZM7.44707 13.3333L13.8337 6.94667L20.2204 13.3333M22.5804 11.92L10.6604 0L8.7804 1.88L11.9537 5.05333L5.08707 11.92C4.3004 12.6667 4.3004 13.96 5.08707 14.7467L12.4204 22.08C12.8071 22.4667 13.3271 22.6667 13.8337 22.6667C14.3404 22.6667 14.8604 22.4667 15.2471 22.08L22.5804 14.7467C23.3671 13.96 23.3671 12.6667 22.5804 11.92Z",
    fill: "#7E5B94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBucket);
export default __webpack_public_path__ + "static/media/paint-bucket.de4b21df214072bca011e916a9748195.svg";
export { ForwardRef as ReactComponent };